import { Injectable, Inject } from "@angular/core";
import {
    ANGULARJS_TRANSLATE,
} from "@nms-ng2/app/shared/services/upgraded-provider/upgraded-providers";
import { NmsToastrService } from "@nms-ng2/app/shared/components/elements/nms-toastr/nms-toastr.service";
import { NmsToasterLink } from "./nms-toastr-model";

/**
 * Serviço utilizado para criar e exibir os toaster de sucesso e erro com um determinado link.
 */
@Injectable({
    providedIn: "root",
})
export class NmsToastrLinkService {

    constructor(private readonly toastr: NmsToastrService,
                @Inject(ANGULARJS_TRANSLATE) private readonly translate: any) {
    }

    /**
     * Método responsável por exibir um toaster de sucesso juntamente com a ação do link criado. O toaster permanecerá na
     * página e somente irá desaparecer após um clique do usuário.
     */
    public showToastSuccess(message: string, links: NmsToasterLink[]): void {
        if (links && links.length > 0) {
            const config = { links: links, disableTimeOut: true };

            this.toastr.success(message, null, config).onAction.subscribe((toastr) => toastr.action());
        } else {
           this.toastr.success(message);
        }
    }

    /**
     * Método responsável por exibir um toaster de erro juntamente com a ação do link criado. O toaster permanecerá na
     * página e somente irá desaparecer após um clique do usuário.
     */
    public showToastError(message: string, links: Array<NmsToasterLink>): void {
        // @ts-ignore
        this.toastr.error(message, null, { links: links }).onAction.subscribe((toastr) => toastr.action());
    }
}
